import { environment } from "../environments/evironment";

export default{
    /**
     * post messages listener
     */
    messagesListener(){
        console.log("--- messagesListener");
        var _this=this;
        window.addEventListener('message', function receptor(e) {
           console.log("MSG->> "+e.origin,e.data)
            var origins = environment.MESSAGE_ORIGIN.split(",");
            console.log(e.origin)
            if(origins.indexOf(e.origin)>=0 && e.origin!==""){
                _this.eventRouter(e.data);
            }
         }, false);
    },
    /**
     * message event router
     * @param {*} eventData 
     */
    eventRouter(eventData){
        eventData = JSON.parse(eventData);
        switch (eventData.type) {
            case "chat":
                this.chatEvent(eventData);
                break;
            case "modifier":
                this.modifierEvent(eventData);
                break;
            case "event":
                this.actionEvent(eventData);
                break;
            case "PCOevent":
                this.PCOevent(eventData);
                break;
          }
 
    },
    chatEvent(eventData){
        if(eventData.data.status=="close"){
            this.closeIframe();
        }
        if(eventData.data.status=="open"){
            this.hideCloseBtnIframe(eventData);
        }
    },
    modifierEvent(eventData){
        if(eventData.data.element=="bar"){
            if(eventData.data.status=="hide"){
                this.hideCloseBtnIframe(eventData);
            }
            if(eventData.data.status=="show"){
                this.showCloseBtnIframe(eventData);
            }
        } 
    },
    actionEvent(eventData){
        if(eventData.data.status=="close"){
            this.closeIframe();
        }
    },
    closeIframe(){
        var dgElement = document.getElementById("digital-gate");

        var iframes = dgElement.querySelectorAll("#iframecontainer");
        iframes.forEach(function (element){
            var classListIframeContainer = Array.from(element.classList);
            if(classListIframeContainer.indexOf("iframeDown") < 0){
                element.classList.add("iframeDown");
                setTimeout(() => {
                    element.querySelector(".closeIframe").classList.remove("noDisplay");
                  }, 400);
            }
        });        
    },
    hideCloseBtnIframe(eventData){
        var dgElement = document.getElementById("digital-gate");
        var channelName = eventData["data"].channel;
        var channelWindow = dgElement.querySelector(`[data-channel='${channelName}']`);
        channelWindow.querySelector(".closeIframe").classList.add("noDisplay");
    },
    showCloseBtnIframe(eventData){
        var dgElement = document.getElementById("digital-gate");
        var channelName = eventData["data"].channel;
        var channelWindow = dgElement.querySelector(`[data-channel='${channelName}']`);
        channelWindow.querySelector(".closeIframe").classList.remove("noDisplay");
    },
    PCOevent(eventData){
        var msgData = JSON.parse(eventData.data.message);
        var divTarget = document.createElement('div');
        divTarget.setAttribute('dir', 'rtl');

        var customBtn = document.createElement('button');
        customBtn.setAttribute('idChat', msgData.idChat);
        customBtn.setAttribute('title', msgData.modulo);

        divTarget.appendChild(customBtn);
        divTarget.style.display="none";
        document.body.appendChild(divTarget);

        customBtn.click();
        setTimeout(() => {
            divTarget.remove();
        }, 100);
    }
};